import styled, { css } from 'styled-components';

/**
 * 공통 Badge — 라벨/칩/태그 통일
 *
 * 사용:
 *   <Badge>학원</Badge>            // 기본 soft(연보라+보라)
 *   <Badge $variant="soft">…</Badge>
 *   <Badge $variant="green">…</Badge>
 *   <Badge $size="sm">…</Badge>    // 작은 사이즈
 *   <Badge $variant="urgent">…</Badge>  // 상태/역할 등 강한 색
 */

const SOFT = (bg, fg) => css`
  background: ${bg};
  color: ${fg};
`;

const STRONG = (bg) => css`
  background: ${bg};
  color: #fff;
`;

const variantStyles = {
  // 부드러운 라벨 (가장 흔함) — 흰 배경 + 진한 글씨 + 미세 보더
  soft: css`
    background: #fff;
    color: ${({ theme }) => theme.colors.text.primary};
    border: 1px solid ${({ theme }) => theme.colors.border};
  `,
  green: SOFT('#E6F4EA', '#15803D'),
  gold: SOFT('#FEF3C7', '#92400E'),
  red: SOFT('#FEE2E2', '#B91C1C'),
  blue: SOFT('#DBEAFE', '#1E40AF'),
  gray: SOFT('#F2F3F7', '#4B5563'),

  // 강한 상태 색 (출석 상태·역할 등 기존 호환)
  urgent: STRONG('#EF5350'),
  inProgress: STRONG('#42A5F5'),
  completed: STRONG('#22C55E'),
  notSubmitted: STRONG('#FF9800'),
  teacher: STRONG('#4F46E5'),
  student: STRONG('#22C55E'),
  assistant: STRONG('#F59E0B'),
  parent: STRONG('#AB47BC'),

  // 옛 이름 호환
  subject: css`
    background: ${({ theme }) => theme.colors.primaryLight};
    color: ${({ theme }) => theme.colors.primary};
  `,
  subjectGreen: SOFT('#E8F5E9', '#15803D'),
  subjectPurple: SOFT('#F3E5F5', '#7B1FA2'),
  notice: SOFT('#FFEBEE', '#EF5350'),
};

const sizeStyles = {
  sm: css`
    padding: 3px 8px;
    border-radius: 7px;
    font-size: 11.5px;
  `,
  md: css`
    padding: 4px 10px;
    border-radius: 9px;
    font-size: 12.5px;
  `,
  lg: css`
    padding: 6px 12px;
    border-radius: 11px;
    font-size: 13px;
  `,
};

const Badge = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  width: fit-content;
  font-weight: 700;
  white-space: nowrap;
  flex-shrink: 0;
  ${({ $size }) => sizeStyles[$size] || sizeStyles.md}
  ${({ $variant }) => variantStyles[$variant] || variantStyles.soft}
`;

export default Badge;
